import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.dashboard.sections.upcomingInvoice.title',
    defaultMessage: 'Upcoming invoice',
    description: 'title of the upcoming invoice section on the dashboard',
  },
  subtotal: {
    id: 'properties.subtotal',
    defaultMessage: 'Subtotal',
    description: 'label of the subtotal in the upcoming invoices section',
  },
  total: {
    id: 'properties.total',
    defaultMessage: 'Total',
    description: 'label of the total in the upcoming invoices section',
  },
  trialPeriod: {
    id: 'properties.trialPeriod',
    defaultMessage: 'Trial period',
    description: 'label of the trial periode in the upcoming invoices section',
  },
};

export default defineMessages(translations);
